import { render, staticRenderFns } from "./licensesCountCard.vue.html?vue&type=template&id=55ab133a&"
import script from "./licensesCountCard.ts?vue&type=script&lang=ts&"
export * from "./licensesCountCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports